<button
  [type]="buttonType()"
  mat-button
  [color]="color()"
  [routerLink]="routerLink() || null"
  [queryParams]="queryParams()"
  (click)="emitClick($event)"
  [ngClass]="{
    'mat-mdc-button mat-mdc-raised-button': matType() === MatButtonType.RAISED,
    'mdc-button--outlined mat-mdc-outlined-button':
      matType() === MatButtonType.STROKED,
    'mat-mdc-unelevated-button': matType() === MatButtonType.FLAT,
    'mat-mdc-menu-item mdc-list-item': matType() === MatButtonType.MENU
  }"
  class="w-100"
  [disabled]="disabled()"
  [matTooltip]="label()"
>
  @if(icon()){
  <mat-icon class="s-me-1"> {{ icon() }} </mat-icon>
  } @if(label()){
  <span>{{ label() | transloco }}</span>
  }
</button>
